import React from 'react';
import { useLocation } from 'react-router-dom';

// CRA `public/` klasöründen import yapmadığı için asset'ler runtime URL ile referanslanır.
const PUBLIC_URL = process.env.PUBLIC_URL || '';
const footerLogo     = `${PUBLIC_URL}/images/logo.webp`;
const footerWorldMap = `${PUBLIC_URL}/images/footer-2-bg-overlay.png`;

// Mirror tek dil/tek tema modunda çalıştığı için Docusaurus context yerine sabit
// değerler kullanılıyor.
const LANG = 'en';
const IS_TR = false;

function WhatsAppIcon({ size }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
        </svg>
    );
}

const FOOTER_TEXT = {
    tr: {
        ctaTitle: 'Web Sitenizi Bugün Başlatın',
        ctaDescription: '25.000+ kayıtlı domain, 40 Trustpilot değerlendirmesi ve 12+ küresel lokasyonla desteklenen güvenilir altyapıyla başlayın.',
        viewPricing: 'Fiyatları Görüntüle',
        contactSales: 'Satış ile İletişim',
        moneyBack: '30 Gün Para İade Garantisi',
        support247: '7/24 Destek',
        uptime: '%99.9 Uptime',
        description: 'İster e-ticaret sitesi ister web işletmesi yönetin, mümkün olduğunca çok ziyaretçi çekmek veya paylaşımlı hosting sınırlamalarından kurtulmak istiyorsanız doğru yerdesiniz.',
        socialMedia: 'Sosyal Medya',
        gameServers: 'Oyun Sunucuları',
        services: 'Hizmetler',
        company: 'Şirket',
        otherGames: 'Diğer Oyunlar',
        dedicated: 'Dedicated',
        webHosting: 'Web Hosting',
        domains: 'Domainler',
        about: 'Hakkımızda',
        contact: 'İletişim',
        references: 'Referanslar',
        ddosProtection: 'DDoS Koruması',
        payment: 'Ödeme Yöntemleri',
        terms: 'Hizmet Sözleşmesi',
        privacy: 'Gizlilik Politikası',
    },
    en: {
        ctaTitle: 'Launch Your Website Today',
        ctaDescription: 'Start with trusted infrastructure backed by 25,000+ registered domains, 40 Trustpilot reviews, and 12+ global locations.',
        viewPricing: 'View Pricing Plans',
        contactSales: 'Contact Sales',
        moneyBack: '30-Day Money-Back Guarantee',
        support247: '24/7 Support',
        uptime: '99.9% Uptime',
        description: 'Whether you run an e-commerce site or a web business, you want to attract as many visitors as possible or for when you no longer want to be limited by shared hosting.',
        socialMedia: 'Social Media',
        gameServers: 'Game Servers',
        services: 'Services',
        company: 'Company',
        otherGames: 'Other Games',
        dedicated: 'Dedicated',
        webHosting: 'Web Hosting',
        domains: 'Domains',
        about: 'About',
        contact: 'Contact',
        references: 'References',
        ddosProtection: 'DDoS Protection',
        payment: 'Payment',
        terms: 'Terms & Conditions',
        privacy: 'Privacy Policy',
    },
};

export default function RabisuFooter() {
    const { pathname } = useLocation();
    const lang = LANG;
    const isTr = IS_TR;
    const t = FOOTER_TEXT[lang] || FOOTER_TEXT.en;

    // Mirror SPA içinde anasayfa /home (ya da kök / yönlendirme öncesi).
    const isHomePage = pathname === '/home' || pathname === '/' || pathname === '';

    return (
        <>
            {isHomePage && (
                <section className="final-cta-section">
                    <div className="container">
                        <div className="final-cta-content">
                            <h2 className="final-cta-title">{t.ctaTitle}</h2>
                            <p className="final-cta-description">{t.ctaDescription}</p>
                            <div className="final-cta-buttons">
                                <a href={`https://www.rabisu.com/${lang}/hosting#pricing`} className="btn btn-light btn-lg">
                                    {t.viewPricing}
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <line x1="5" y1="12" x2="19" y2="12" />
                                        <polyline points="12 5 19 12 12 19" />
                                    </svg>
                                </a>
                                <a href={`https://www.rabisu.com/${lang}/${isTr ? 'iletisim' : 'contact'}`} className="btn btn-outline-light btn-lg">
                                    {t.contactSales}
                                </a>
                            </div>
                            <div className="final-cta-trust">
                                <p>
                                    <i className="fas fa-shield-alt" /> {t.moneyBack}
                                    <span className="separator">•</span>
                                    <i className="fas fa-headset" /> {t.support247}
                                    <span className="separator">•</span>
                                    <i className="fas fa-server" /> {t.uptime}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <footer className="rabisu-site-footer">
                <div className="footer-world-map" style={{ backgroundImage: `url('${footerWorldMap}')` }} />

                <div className="footer-main">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
                                <div className="footer-brand">
                                    <img src={footerLogo} alt="Rabisu" className="footer-logo" width="140" height="45" />
                                    <p className="footer-description">{t.description}</p>
                                    <h3 className="footer-social-title">{t.socialMedia}</h3>
                                    <div className="footer-social-links">
                                        <a href="https://discord.gg/S5TmMxn" className="footer-social-icon" rel="nofollow" target="_blank" title="Discord">
                                            <i className="fab fa-discord" />
                                        </a>
                                        <a href="https://www.facebook.com/rabisusistem" className="footer-social-icon" rel="nofollow" target="_blank" title="Facebook">
                                            <i className="fab fa-facebook-f" />
                                        </a>
                                        <a href="https://twitter.com/rabisucom" className="footer-social-icon" rel="nofollow" target="_blank" title="Twitter">
                                            <i className="fab fa-twitter" />
                                        </a>
                                        <a href="https://instagram.com/rabisutr" className="footer-social-icon" rel="nofollow" target="_blank" title="Instagram">
                                            <i className="fab fa-instagram" />
                                        </a>
                                        <a href="https://www.youtube.com/c/Rabisu/" className="footer-social-icon" rel="nofollow" target="_blank" title="YouTube">
                                            <i className="fab fa-youtube" />
                                        </a>
                                        <a href="https://whatsapp.com/channel/0029Vb6MQFl7IUYSdDxyTG45" className="footer-social-icon" rel="nofollow" target="_blank" title="WhatsApp">
                                            <WhatsAppIcon size={18} />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                                <div className="footer-col">
                                    <h3 className="footer-col-title">{t.gameServers}</h3>
                                    <ul className="footer-links">
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'minecraft-server-kurma' : 'minecraft-server-hosting'}`}>Minecraft</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'rust-sunucu' : 'rust-server-hosting'}`}>Rust</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'garrys-mod-sunucu' : 'garrys-mod-server-hosting'}`}>Garry&apos;s Mod</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'ark-sunucu' : 'ark-server-hosting'}`}>ARK</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'oyun-sunucusu' : 'game-server'}`}>{t.otherGames}</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
                                <div className="footer-col">
                                    <h3 className="footer-col-title">{t.services}</h3>
                                    <ul className="footer-links">
                                        <li><a href={`https://www.rabisu.com/${lang}/dedicated-server`}>{t.dedicated}</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/vps`}>VPS</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/hosting`}>{t.webHosting}</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'domain-sorgula' : 'domains'}`}>{t.domains}</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-6">
                                <div className="footer-col">
                                    <h3 className="footer-col-title">{t.company}</h3>
                                    <ul className="footer-links">
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'biz-kimiz' : 'who-are-we'}`}>{t.about}</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'iletisim' : 'contact'}`}>{t.contact}</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'referanslar' : 'references'}`}>{t.references}</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'ddos-korumasi' : 'ddos-protection'}`}>{t.ddosProtection}</a></li>
                                        <li><a href={`https://www.rabisu.com/${lang}/${isTr ? 'odeme-yontemleri' : 'payment-methods'}`}>{t.payment}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="container">
                        <div className="footer-bottom-content">
                            <p className="footer-copyright">&copy; {new Date().getFullYear()} Rabisu. All rights reserved</p>
                            <div className="footer-bottom-links">
                                <a href={`https://www.rabisu.com/${lang}/${isTr ? 'hizmet-sozlesmesi' : 'service-contract'}`}>{t.terms}</a>
                                <a href={`https://www.rabisu.com/${lang}/${isTr ? 'hizmet-sozlesmesi' : 'service-contract'}`}>{t.privacy}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
